import * as React from 'react';
import { storyblokEditable } from 'gatsby-source-storyblok';
import clsx from 'clsx';
import { Link } from 'gatsby';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { icon } from '@fortawesome/fontawesome-svg-core';
import { useLocation } from '@reach/router';
import { extractLanguage } from '../../helpers/common';

export default function ReferencesTiles({ blok }) {
  const location = useLocation();

  const currentLanguage = extractLanguage(location.pathname);

  const { tile, component } = blok;
  if (!tile) return null;

  const styles = clsx(
    `${component} px-4 lg:px-16 grid gap-4 grid-cols-1 s:grid-cols-2 md:grid-cols-3 xl:grid-cols-4 pb-8 lg:pb-32`,
  );

  // Extract the relevant segment from the first tile's full_slug
  const parentRoute = currentLanguage === 'en' ? '/en/references' : '/references';

  return (
    <div {...storyblokEditable(blok)} className={styles}>
      {tile?.map((item) => (
        <div
          className="aspect-[16/9] relative h-full overflow-hidden"
          key={tile.title}
        >
          {item && (
            <img
              src={item?.content?.image?.filename}
              className="w-auto object-cover h-full"
              alt={item?.content?.image?.alt}
            />
          )}
          <Link
            to={`/${item?.full_slug}`}
            className="absolute top-0 w-full h-full flex"
          >
            <div className="absolute w-full h-full bg-green-800 z-10 opacity-75 hover:bg-slate-700 hover:opacity-20 transition" />
            <div className="m-auto z-20 pointer-events-none">
              {item ? (
                <img
                  src={item?.content?.logo?.filename}
                  width="300"
                  height="200"
                  className="max-h-8 s:max-h-12 xl:max-h-16 h-full max-w-[100px] s:max-w-[150px] xl:max-w-[175px] w-full object-contain"
                  alt={item?.content?.logo?.alt}
                  loading="lazy"
                />
              ) : (
                <h4>reference title</h4>
              )}
            </div>
          </Link>
        </div>
      ))}
      {blok?.showmore_tile && (
        <Link
          to={parentRoute}
          className="flex bg-green-800 hover:bg-green-900 text-white group aspect-[16/9]"
        >
          <div className="flex m-auto items-center group-hover:scale-105 transition-transform">
            <span className="mr-2">
              {currentLanguage === 'default' ? 'Mehr' : 'More'}
            </span>
            <FontAwesomeIcon
              icon={icon({ prefix: 'far', iconName: 'arrow-right' })}
              size="2x"
            />
          </div>
        </Link>
      )}
    </div>
  );
}
